import { render, staticRenderFns } from "./two-users.vue?vue&type=template&id=7f757f21&"
import script from "./two-users.vue?vue&type=script&lang=js&"
export * from "./two-users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports